import { TwinEmployeeParametersDict } from '@teinor/erp/types/company/userInner/employeeParameter'
import { useCallback, useState } from 'react'
import { ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { ModalOpenedSetTy } from '../../../../../../../../baseComponents/Modal/types'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../../forms/FormRenderer'
import { FormElement, FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { twinFetchPostText } from '../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { changeErrorMessage } from '../../../../../../../../utils/reducers/reduxDispatch'

interface ConfigEmployeeMultiUserPassCustomRenderProps {
    setOpened: ModalOpenedSetTy
}

export const ConfigEmployeeMultiUserPassCustomRender: React.FC<ConfigEmployeeMultiUserPassCustomRenderProps> = ({ setOpened }: ConfigEmployeeMultiUserPassCustomRenderProps) => {
    return (
        <ConfigureEmployeeMultiUserPass setOpened={setOpened} />
    )
}

interface ConfigureEmployeeMultiUserPassProps {
    setOpened: ModalOpenedSetTy
}
const ConfigureEmployeeMultiUserPass: React.FC<ConfigureEmployeeMultiUserPassProps> = ({ setOpened }) => {
    return (
        <div className='gap-10 flex flex-row items-center'>
            <span><TwinTrans transKey={'accessFromOtherUsersConfig'}>Configurar acceso desde otro usuario</TwinTrans>:</span>
            <ButtonSecondary className='w-fit' type='button' onClick={() => setOpened(true)} key={'configEmployeeMultiUserPass'}><TwinTrans transKey={'Config'}>Configurar</TwinTrans></ButtonSecondary>
        </div>
    )
}

interface ModalEmployeeMultiUserPassProps extends ModalEmployeeMultiUserPassLogicProps { }

export const ModalEmployeeMultiUserPass: React.FC<ModalEmployeeMultiUserPassProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()

    const { changeValue, handleOnAccept, data } = useModalEmployeeMultiUserPassLogic({ setOpened, ...rest })
    const myElements: FormElement<keyof TwinEmployeeParametersDict>[] = []
    if (!data.accesibleWithoutPassword){
        myElements.push(
            {
                name: 'password',
                label: t('password', 'Contraseña'),
                component: 'InputWithLabelMargin',
                type: 'password',
                onChange: (val) => changeValue('password', val),
                required: true
            },
            {
                name: 'repeatPassword',
                label: t('repeatPass', 'Repetir contraseña'),
                component: 'InputPasswordWithLabel',
                type: 'password',
                onChange: (val) => changeValue('repeatPassword', val),
                required: true
            },
        )
    }
    const fields: FormRender<TwinEmployeeParametersDict> = [
        {
            cols: 1,
            elements: [
                ...myElements,
                {
                    name: 'accesibleOtherUsers',
                    label: t('accesibleOtherUsers', 'Accesible desde otros usuarios'),
                    onChange: (val) => changeValue('accesibleOtherUsers', val),
                    component: 'CheckboxMargin',
                    className: 'mx-auto max-w-350 w-full',
                    checked: data.accesibleOtherUsers
                },
                {
                    name: 'accesibleWithoutPassword',
                    label: t('accesibleWithoutPassword', 'Accesible sin contraseña'),
                    onChange: (val) => changeValue('accesibleWithoutPassword', val),
                    component: 'CheckboxMargin',
                    className: 'mx-auto max-w-350 w-full',
                    checked: data.accesibleWithoutPassword
                },
            ]
        },
    ]

    return (
        <ModalSmallFilled opened={true} setOpened={() => {}} onCancel={() => setOpened(null)} onAccept={handleOnAccept} className='flex_height' translations={{
            title: t('configMultiPassUser', 'Configurar contraseña para acceder desde multiusuario'),
            subtitle: t('explanationModifyMultiUserPass', 'Atención no estás modificando la contraseña de la aplicación, solo estás cambiando la contraseña de cuando se accede desde el usuario tienda.'),
            buttonAccept: t('save', 'Guardar'),
        }}>
            <FormRenderer sections={fields} className='text-left mb-10' />
        </ModalSmallFilled>
    )
}

interface ModalEmployeeMultiUserPassLogicProps extends ModalEditComponentProps {
    employeeData: TwinDictionary | null
    url: string
    extraData?: TwinDictionary
}

const useModalEmployeeMultiUserPassLogic = ({onSubmit, setOpened, employeeData, url, extraData}: ModalEmployeeMultiUserPassLogicProps) => {
    const [data, setData] = useState<TwinDictionary>({ accesibleOtherUsers: employeeData?.accesibleOtherUsers, accesibleWithoutPassword: employeeData?.accesibleWithoutPassword })
    const {t} = useTwinTranslation()

    const error = t('notSamePass', 'Las contraseñas no son iguales')

    const changeValue = useCallback((field: string, value: any) => {
        setData((old)=>{
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld[field] = value
            return copyOld
        })
    }, [])

    const handleOnAccept = useCallback(async() => {
        if (data.password !== data.repeatPassword && data?.accesibleWithoutPassword === false){
            changeErrorMessage(error)
        }else{
            if (data?.accesibleWithoutPassword === true){
                delete data?.password
            }
            const res = await twinFetchPostText(url, { ...data, ...extraData, repeatPassword: undefined})
            if(res){
                onSubmit?.(res, {})
                setOpened(null)
            }
        }
    }, [error, data, onSubmit, setOpened, url, extraData])

    return { changeValue, handleOnAccept, data }
}


